// ============================================================================
// ui/tapfix-base-store.js — the logo BEFORE its Clean up logo edits, kept across a reload (WD 505)
// ============================================================================
// Ryan 11-02 (WD 485b's known gap): after a reload the pre-edit art was gone, so on a reopened, edited design a
// Solid / See-through pick replaced the edits and Reset logo only undid that visit. The pre-edit art is a second full
// image, and putting it on the design record would double the autosave and every share link - so it lives HERE, in
// this browser's IndexedDB, filed under a digest of the EDITED art (the record's `dataUrl`, byte for byte what the
// autosave restores). Same browser only, by design: another device opening the design gets the old behaviour.
// Every call fails silent (private window, blocked storage): no entry = the behaviour before this file existed.
// ============================================================================

const DB = 'wd-tapfix';
const STORE = 'bases';
const KEEP = 8; // the newest few edited logos; older entries are pruned on write

function open() {
  return new Promise((res, rej) => {
    if (typeof indexedDB === 'undefined') { rej(new Error('no idb')); return; }
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => { r.result.createObjectStore(STORE, { keyPath: 'k' }); };
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

async function digest(s) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(s)));
  return Array.from(new Uint8Array(buf).slice(0, 16), (b) => b.toString(16).padStart(2, '0')).join('');
}

const done = (tx) => new Promise((res, rej) => { tx.oncomplete = () => res(); tx.onerror = () => rej(tx.error); tx.onabort = () => rej(tx.error); });

/** Remember `baseUrl` as the unedited art of the edited logo `editedUrl`. */
export async function rememberTapFixBase(editedUrl, baseUrl) {
  if (!editedUrl || !baseUrl || editedUrl === baseUrl) return;
  try {
    const k = await digest(editedUrl);
    const db = await open();
    const tx = db.transaction(STORE, 'readwrite');
    const st = tx.objectStore(STORE);
    st.put({ k, base: baseUrl, at: Date.now() });
    const all = await new Promise((res) => { const g = st.getAll(); g.onsuccess = () => res(g.result || []); g.onerror = () => res([]); });
    all.filter((e) => e.k !== k).sort((a, b) => b.at - a.at).slice(KEEP - 1).forEach((e) => st.delete(e.k));
    await done(tx);
    db.close();
  } catch { /* storage unavailable: the reload simply loses it, as before */ }
}

/** The unedited art remembered for `editedUrl`, or null. */
export async function recallTapFixBase(editedUrl) {
  if (!editedUrl) return null;
  try {
    const k = await digest(editedUrl);
    const db = await open();
    const row = await new Promise((res) => {
      const g = db.transaction(STORE, 'readonly').objectStore(STORE).get(k);
      g.onsuccess = () => res(g.result || null); g.onerror = () => res(null);
    });
    db.close();
    return row && row.base ? row.base : null;
  } catch { return null; }
}
